export default (name: string | undefined) => {
    const key = (name || "").trim().toLowerCase().replaceAll(" ", "-")
    switch (key) {
        case "ring":
            return "/images/sketches/types/ring.png"
        case "bracelet":
            return "/images/sketches/types/bracelet.png"
        case "earrings":
            return "/images/sketches/types/earrings.png"
        case "necklace":
            return "/images/sketches/types/necklace.png"
        case "pendant":
            return "/images/sketches/types/pendant.png"
        case "full-set":
            return "/images/sketches/types/full-set.png"
        case "half-set":
            return "/images/sketches/types/half-set.png"
        case "necklace-set":
            return "/images/sketches/types/necklace-set.png"

        default:
            return "/images/sketches/types/ring.png"
    }
}
